import React, { useState, useEffect } from 'react';
import { Button, Stack, Box, useMediaQuery, CircularProgress } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { getSearchingResident, selectInvitationState } from '../../sagas/invitations/invitationSlice';
import { useSelector, useDispatch } from 'react-redux';
import { ResidentpageState } from '../../ResidentpageState';
import { SearchType } from '@inosio/payments-sdk';
import ExtraLinks from './ExtraLinks';
import { EmailRegex } from '../../../../utils/regex';

interface PropsType {
  setPageState: React.Dispatch<React.SetStateAction<ResidentpageState>>
}

const useStyles = makeStyles({
  input: {
    border: 'none',
    outline: 'none',
    background: '#FFFFFF',
    boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
    boxSizing: 'border-box',
    borderRadius: '24px',
    height: '49px',
    maxWidth: '350px',
    width: '100%',
    padding: '0 10px',
    fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '22px',
  },
  buttonProgress: {
    color: "#053742",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  }
});


export default function SearchResidentByEmail(props: PropsType) {
  const classes = useStyles();
  const matchesMobile = useMediaQuery("(max-width:380px)");
  const [emailAddress, setEmailAddress] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const { isSearchingResident } = useSelector(selectInvitationState);

  useEffect(() => {
    if (EmailRegex.test(emailAddress)) {
      setIsValidEmail(true);
    } else {
      setIsValidEmail(false);
    }
  }, [emailAddress])

  const dispatch = useDispatch();

  const searchResidentByEmail = () => {
    dispatch(
      getSearchingResident({
        SearchType: SearchType.Email,
        Email: emailAddress,
      })
    );
  }

  return (
    <Stack direction='column' justifyContent='center' alignItems="center" spacing={4} sx={{ marginTop: '30px' }}>
      <Box sx={{ width: '100%' }}>
        <input
          placeholder="Enter your email address"
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
          className={classes.input}
        />
      </Box>

      <Stack 
        direction='row' 
        justifyContent='space-between' 
        alignItems="center" 
        sx={{ width: '100%', flexDirection: matchesMobile ? 'column': 'row' }}
      >
        <Button
          variant="outlined"
          sx={{
            width: matchesMobile ? "100%": "200px",
            height: "49px",
            fontSize: '18px',
            borderRadius: "24px",
            textTransform: "none",
            color: "#39A2DB",
            transition: "background 0.55s, color 0.55s",
            borderColor: '#39A2DB',
            '&:hover': {
              backgroundColor: '#39A2DB',
              color: 'white',
              borderColor: '#39A2DB'
            }
          }}
          onClick={() => {props.setPageState(ResidentpageState.SearchPropertiesByAddress)}}
        >
          Search by address
        </Button>     
        <Button
          type="submit"
          variant="contained"
          style={{
            width: matchesMobile ? "100%": "113px",
            marginTop: matchesMobile ? '20px': '',
            height: "49px",
            fontSize: '18px',
            borderRadius: "24px",
            textTransform: "capitalize",
            color: 'white',
            backgroundColor: isValidEmail ? "#39A2DB" : "rgba(211, 211, 211, 1)",
            borderColor: isValidEmail ? "#39A2DB" : "rgba(211, 211, 211, 1)",
          }}
          onClick={searchResidentByEmail}
          disabled={!isValidEmail}
        >
          Search
          {isSearchingResident ? <CircularProgress size={26} className={classes.buttonProgress} /> : <></>}
        </Button>
      </Stack>

      <ExtraLinks />
    </Stack>
  )
}
